import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PermitDetail } from '../../../models/permit-detail.model';

/** Friends & Family detail - common fields plus the host and their confirmation. */
@Component({
    selector: 'app-friends-family-detail',
    templateUrl: './friends-family-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FriendsFamilyDetailComponent {
    @Input() permit!: PermitDetail;
}
